import React from 'react';
import { Link } from 'react-router-dom';

const Resources: React.FC = () => {
  return (
    <div className="resources-page">
      {/* Page Header */}
      <div className="relative bg-primary py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold text-white mb-4 animate-fadeInDown">Resources</h1>
          <nav className="flex justify-center animate-fadeInUp">
            <ol className="flex items-center space-x-2 text-white">
              <li><Link to="/" className="hover:text-secondary">Home</Link></li>
              <li><i className="fas fa-chevron-right mx-2"></i></li>
              <li><Link to="/about" className="hover:text-secondary">About</Link></li>
              <li><i className="fas fa-chevron-right mx-2"></i></li>
              <li className="text-secondary">Resources</li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Resources Section */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12 animate-fadeInUp">
            <h2 className="text-4xl font-bold mb-4">Our Resources</h2>
            <p className="text-gray-600 text-lg">
              Download guides, whitepapers, and other useful materials
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Resource Card 1 */}
            <div className="bg-white rounded-lg shadow-lg p-6 hover:shadow-2xl transition duration-300 animate-fadeInUp">
              <div className="flex items-center mb-4">
                <div className="bg-primary w-16 h-16 rounded-lg flex items-center justify-center mr-4">
                  <i className="fas fa-file-pdf text-white text-2xl"></i>
                </div>
                <div>
                  <h4 className="text-lg font-bold">Company Brochure</h4>
                  <span className="text-sm text-gray-500">PDF - 2.5 MB</span>
                </div>
              </div>
              <p className="text-gray-600 mb-4">
                Download our company brochure to learn more about our services and capabilities.
              </p>
              <button className="bg-secondary hover:bg-primary text-white px-6 py-2 rounded-full transition duration-300 w-full">
                <i className="fas fa-download mr-2"></i> Download
              </button>
            </div>

            {/* Resource Card 2 */}
            <div className="bg-white rounded-lg shadow-lg p-6 hover:shadow-2xl transition duration-300 animate-fadeInUp" style={{ animationDelay: '0.2s' }}>
              <div className="flex items-center mb-4">
                <div className="bg-primary w-16 h-16 rounded-lg flex items-center justify-center mr-4">
                  <i className="fas fa-file-alt text-white text-2xl"></i>
                </div>
                <div>
                  <h4 className="text-lg font-bold">Case Studies</h4>
                  <span className="text-sm text-gray-500">PDF - 3.2 MB</span>
                </div>
              </div>
              <p className="text-gray-600 mb-4">
                Explore our successful project case studies and client testimonials.
              </p>
              <button className="bg-secondary hover:bg-primary text-white px-6 py-2 rounded-full transition duration-300 w-full">
                <i className="fas fa-download mr-2"></i> Download
              </button>
            </div>

            {/* Resource Card 3 */}
            <div className="bg-white rounded-lg shadow-lg p-6 hover:shadow-2xl transition duration-300 animate-fadeInUp" style={{ animationDelay: '0.4s' }}>
              <div className="flex items-center mb-4">
                <div className="bg-primary w-16 h-16 rounded-lg flex items-center justify-center mr-4">
                  <i className="fas fa-book text-white text-2xl"></i>
                </div>
                <div>
                  <h4 className="text-lg font-bold">Technical Guide</h4>
                  <span className="text-sm text-gray-500">PDF - 4.1 MB</span>
                </div>
              </div>
              <p className="text-gray-600 mb-4">
                Access our comprehensive technical guide and documentation.
              </p>
              <button className="bg-secondary hover:bg-primary text-white px-6 py-2 rounded-full transition duration-300 w-full">
                <i className="fas fa-download mr-2"></i> Download
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Resources;